<pagination-template
  #p="paginationApi"
  [id]="id"
  [maxSize]="maxSize"
  (pageChange)="pageChange.emit($event)"
  (pageBoundsCorrection)="pageBoundsCorrection.emit($event)">
  <nav
    *ngIf="!(autoHide && p.pages.length <= 1)"
    [attr.aria-label]="screenReaderPaginationLabel">
    <ul class="ngx-pagination" role="list" [class.responsive]="responsive">
      <li
        class="pagination-previous"
        role="listitem"
        [class.disabled]="p.isFirstPage()"
        [attr.aria-disabled]="p.isFirstPage() ? true : null"
        *ngIf="directionLinks">
        <button
          type="button"
          *ngIf="p.getCurrent() > 1"
          (click)="p.previous()"
          [attr.aria-label]="previousLabel + ' ' + screenReaderPageLabel">
          {{ previousLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
        </button>
        <span *ngIf="p.isFirstPage()">
          {{ previousLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
        </span>
      </li>

      <li class="small-screen" role="listitem">{{ p.getCurrent() }} / {{ p.getLastPage() }}</li>

      <li
        role="listitem"
        [class.current]="p.getCurrent() === page.value"
        [class.ellipsis]="page.label === '...'"
        *ngFor="let page of p.pages">
        <button
          type="button"
          *ngIf="p.getCurrent() !== page.value"
          (click)="p.setCurrent(page.value)"
          [attr.aria-label]="screenReaderPageLabel + ' ' + (page.label === '...' ? page.label : (page.label | number:''))">
          <span class="show-for-sr">{{ screenReaderPageLabel }} </span>
          <span aria-hidden="true">{{ page.label === '...' ? page.label : (page.label | number:'') }}</span>
        </button>
        <ng-container *ngIf="p.getCurrent() === page.value">
          <span class="show-for-sr">{{ screenReaderCurrentLabel }} </span>
          <span aria-current="page">{{ page.label === '...' ? page.label : (page.label | number:'') }}</span>
        </ng-container>
      </li>

      <li
        class="pagination-next"
        role="listitem"
        [class.disabled]="p.isLastPage()"
        [attr.aria-disabled]="p.isLastPage() ? true : null"
        *ngIf="directionLinks">
        <button
          type="button"
          *ngIf="!p.isLastPage()"
          (click)="p.next()"
          [attr.aria-label]="nextLabel + ' ' + screenReaderPageLabel">
          {{ nextLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
        </button>
        <span *ngIf="p.isLastPage()">
          {{ nextLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
        </span>
      </li>
    </ul>
  </nav>
</pagination-template>
